<template>
	<div id="orderVideo">
		<div class="contentPageTop">
			<div class="contentPageTitle">
				<Icon custom="iconfont icon-video" size="26" />
				<span>点播视频</span>
			</div>
			<div class="orderVideoScreen">
				<csreen @csData="getScreenData" ref="screenSearch"></csreen>
			</div>
		</div>
		<div class="listLaoding" v-if="boxState=='1'">
			<boxLoading style="height: 300px; background: none;" :background="false"></boxLoading>
		</div>
		<div class="orderVideoList" v-else-if="boxState=='2'">
			<videoBox :videoArr="orderArr"></videoBox>
			<cpage :pageData="page" @clickPage="pageChange" style="margin-top: 20px;"></cpage>
		</div>
		<div class="errTips" v-else>
			<noerr :nothingNum="nothing" :boxState="boxState" @refSearch="refscreenSearch"></noerr>
		</div>

	</div>
</template>
<script>
	import csreen from "../../../components/content/screen.vue";
	import videoBox from "../../../components/content/videoBox.vue";
	import cpage from "../../../components/content/page.vue";
	import loading from "../../../components/content/loading.vue";
	import boxLoading from "../../../components/tools/loading.vue";
	import noerr from "../../../components/tools/noerr.vue";
	import {
		courseList
	} from '../../../request/api.js';
	export default {
		name: "orderVideo",
		components: {
			csreen,
			videoBox,
			cpage,
			boxLoading,
			noerr
		},
		data() {
			return {
				orderArr: [],
				boxState: '1',
				page: {
					pageTotal: 0,
					pageSize: 8,
					pageNow: 0
				},
				screen: {
					name: '',
					typeId: ''
				},
				nothing: 0
			};
		},
		methods: {
			refscreenSearch() {
				this.$refs.screenSearch.empty();
				this.page.pageNow = 0
			},
			// 搜索
			getScreenData(data) {
				this.screen.name = data.keyWords;
				if (data.dep.length != 0) {
					this.screen.typeId = data.dep[data.dep.length - 1].id;
				} else {
					this.screen.typeId = ''
				}

				this.page.pageNow = 0;
				this.getCourse()
			},
			// 分页
			pageChange(data) {
				this.page.pageNow = data - 1;
				this.getCourse()
			},
			// 获取
			getCourse() {
				this.boxState = '1';
				this.orderArr = [];
				let order = {
					courseType: 'DB',
					page: this.page.pageNow,
					size: this.page.pageSize,
					name: this.screen.name,
					typeId: this.screen.typeId
				}
				courseList(order).then(res => {
					this.nothing++
					if (res.content == '') {
						setTimeout(() => {
							this.boxState = '3'
						}, 500)
					} else {
						this.orderArr = res.content;
						this.page.pageTotal = res.totalElements;
						setTimeout(() => {
							this.boxState = '2'
						}, 500)
					}

				}).catch(err => {
					console.log(err)
					this.boxState = '4'
				})
			}
		},
		mounted() {
			setTimeout(() => {
				this.pageSpin = false
			}, 1000)
			this.getCourse()
		}
	};
</script>

<style>
	#orderVideo {
		height: 100%;
		width: 100%;
	}

	.orderVideoScreen {
		margin-top: 20px;
	}

	.orderVideoList,
	.listLaoding {
		position: relative;
		/* margin-top: 20px; */
	}
</style>